import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type { GetPingResponse } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  children?: (data: GetPingResponse) => ReactElement
}

const PingAiApiService = ({
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/ping`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      url={url}
    />
  )
}

export default PingAiApiService
